export default __webpack_public_path__ + "static/media/illustration.1f5cdf4d.jpg";